import { Component, Input, Output, EventEmitter, ElementRef, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, takeUntil, filter } from 'rxjs/operators';

@Component({
  selector: 'unh-search-input',
  styleUrls: ['./search-input.component.scss'],
  template: `
    <div #searchInput>
      <ng-content select="[search-input]"></ng-content>
    </div>
  `
})
export class SearchInputComponent implements AfterViewInit, OnDestroy {
  private destroyEvent$ = new Subject();
  @Input() debounceTime = 500;
  @Input() minChar = 3;
  @Output() valueChanged = new EventEmitter<string>();
  @ViewChild('searchInput') divRef: ElementRef<HTMLDivElement>;

  ngAfterViewInit(): void {
    const divEl = this.divRef.nativeElement;
    fromEvent(divEl, 'input').pipe(
      map(evt => (evt.target as HTMLInputElement).value),
      filter(value => value.length === 0 || value.length >= this.minChar),
      takeUntil(this.destroyEvent$),
      debounceTime(this.debounceTime),
      distinctUntilChanged()
    ).subscribe(value => {
      this.valueChanged.emit(value);
    });
  }

  ngOnDestroy(): void {
    this.destroyEvent$.next(true);
    this.destroyEvent$.complete();
  }
}
